import React, { useCallback, useMemo } from 'react';

import { FlatList, ListRenderItemInfo, View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import CheckMarkImage from 'assets/images/svgs/ico_checkmark.svg';

import gStyles from 'config/styles';

import { selectLayoutConfig } from 'store/config/selectors';
import { setPlayerSubtitles } from 'store/player/actions';
import { selectPlayerSubtitles } from 'store/player/selectors';
import { selectActiveUserProfile } from 'store/user/selectors';

import useHeaderConfig from 'utils/hooks/useHeaderConfig';
import { isWeb } from 'utils/responsiveness';

import SettingsRowItem from '../../components/RowItem';
import WebHeader from '../../components/WebHeader';
import { SUBTITLES_OPTIONS } from '../../constants';
import { SETTINGS_SUBTITLE_LANGUAGE } from '../../languagesConst';
import { SubtitlesSettingItem } from '../../types';

function Subtitles() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { background } = useSelector(selectLayoutConfig);
    const selectedSubtitles = useSelector(selectPlayerSubtitles);
    const selectedProfileId = useSelector(selectActiveUserProfile);

    useHeaderConfig({ isRoot: isWeb });

    const listStyle = useMemo(
        () => ({
            backgroundColor: background,
        }),
        [background],
    );

    const handleChangeSubtitles = useCallback(
        ({ id }: SubtitlesSettingItem) => {
            if (selectedProfileId) {
                dispatch(setPlayerSubtitles(selectedProfileId, id));
            }
        },
        [dispatch, selectedProfileId],
    );

    const renderItem = useCallback(
        ({ item, index }: ListRenderItemInfo<SubtitlesSettingItem>) => (
            <SettingsRowItem
                item={item}
                title={t(item.title)}
                onPress={handleChangeSubtitles}
                RightIcon={
                    selectedSubtitles === item.id ? CheckMarkImage : undefined
                }
                position={index + 1}
                total={SUBTITLES_OPTIONS.length}
                isSelected={selectedSubtitles === item.id}
            />
        ),
        [handleChangeSubtitles, selectedSubtitles, t],
    );

    return (
        <View style={[gStyles.settingsContainer, listStyle]}>
            {isWeb && (
                <WebHeader
                    title={t(SETTINGS_SUBTITLE_LANGUAGE)}
                    disableFocusOnMount
                />
            )}
            <FlatList
                style={gStyles.settingsContentContainer}
                nestedScrollEnabled
                data={SUBTITLES_OPTIONS}
                keyExtractor={keyExtractor}
                renderItem={renderItem}
                showsHorizontalScrollIndicator={false}
                accessibilityRole="menu"
            />
        </View>
    );
}

export default Subtitles;

function keyExtractor({ id }: SubtitlesSettingItem) {
    return id;
}
